import { MarketNetwork } from "../cefi";
import { Any } from "../fakeTypes";

export type DropListWithIconItem<T = Record<string, unknown>> = {
  label: string;
  value: string;
  isDisabled?: boolean;
  disabledText?: string;
  img: string;
  defaultImg?: string;
} & T;

export type AssetItemListProps<T = Record<string, unknown>> = {
  label: string;
  value: string;
  name?: string;
  img: string;
  amount: number | string;
  amountRef: number | string;
  params?: Any;
} & T;

export type CurrencyDropListWithIconItem<T = Record<string, unknown>> = DropListWithIconItem<
  {
    amount: string;
    balance: string;
    freeBalance: number;
    searchableTerms?: string[];
  } & T
>;

export type SupportedTokensDropListWithIconItem<T = Record<string, unknown>> = DropListWithIconItem<
  {
    searchableTerms?: string[];
    networks: MarketNetwork[];
  } & T
>;
